import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { DsLibMainMenuComponent } from './ds-lib-main-menu.component';
import { DsLibCommonModule, DsLibProfileBarModule, DsLibSearchAutocompleteModule } from '@sixense/ds-lib-common';
import { DsLibDisconnectButtonComponent } from './components/ds-lib-disconnect-button/ds-lib-disconnect-button.component';
import { DsLibDropdownListComponent } from './components/ds-lib-dropdown-list/ds-lib-dropdown-list.component';
import { DsLibSectionComponent } from './components/ds-lib-section/ds-lib-section.component';
import { DsLibCheckRightsPipe } from './pipes/ds-lib-check-rights.pipe';
import { DsLibMainMenuRouterLinkPipe } from './pipes/ds-lib-main-menu-router-link.pipe';

@NgModule({
  declarations: [
    DsLibMainMenuComponent,
    DsLibDisconnectButtonComponent,
    DsLibDropdownListComponent,
    DsLibSectionComponent,
    DsLibCheckRightsPipe,
    DsLibMainMenuRouterLinkPipe,
  ],
  imports: [DsLibCommonModule, RouterModule, DsLibProfileBarModule, DsLibSearchAutocompleteModule],
  exports: [DsLibMainMenuComponent],
})
export class DsLibMainMenuModule {}
